"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EsText = void 0;
const CommonDto_1 = require("../dto/CommonDto");
class EsText {
    constructor(type, text) {
        this.type = type;
        this.value = text;
    }
    copy() {
        return EsText.copy(this, EsText.createEmpty());
    }
    static copy(source, target) {
        target.type = source.type;
        target.value = source.value;
        return target;
    }
    static createEmpty() {
        return new EsText(CommonDto_1.TextType.TXT, "");
    }
    get notEmpty() {
        return !!this.value;
    }
    get isMarkdown() {
        return this.type === CommonDto_1.TextType.MD;
    }
    static fromTextDto(text) {
        return new EsText(text.textType ? text.textType : CommonDto_1.TextType.TXT, text.value ? text.value : "");
    }
    static fromOptionalTextDto(optionalText) {
        if (!optionalText || optionalText.type === CommonDto_1.OptionalTextTypeDto.EMPTY) {
            return this.createEmpty();
        }
        else {
            return this.fromTextDto(optionalText);
        }
    }
    toTextDto() {
        return { textType: this.type, value: this.value };
    }
    toOptionalTextDto() {
        return { type: CommonDto_1.OptionalTextTypeDto.TEXT, textType: this.type, value: this.value };
    }
    equals(esText) {
        return this.type === esText.type
            && this.value === esText.value;
    }
}
exports.EsText = EsText;
